// @flow
import without from 'lodash/without';

import {
  MAP_SET_VIEWPORT,
  MAP_RESET_VIEWPORT,
  MAP_SET_FIT_BOUNDS,
  MAP_SET_CENTER,
  MAP_SET_BACKGROUND,
  MAP_TOGGLE_EXTRUSION,
  MAP_TOGGLE_EXTRUSION_RAW,
  MAP_TOGGLE_STYLE_CATEGORY,
  MAP_TOGGLE_AIRPORTS,
  MAP_TOGGLE_AIRCRAFTS,
  MAP_SET_VISIBLE_AIRSPACES,
  MAP_SET_SELECTED_FEATURE,
} from 'actions/map';

import { STYLE_CATEGORIES } from 'utils/mapStyle';

const INITIAL_STATE = {
  viewport: {
    center: [19.5, 47.2],
    bearing: 0,
    pitch: 0,

    zoom: [7],
    fitBounds: null,
    flyToOptions: {},
  },

  visibleAirspaces: [],
  selectedFeature: null,

  background: 'osm',
  styleCategories: Object.keys(STYLE_CATEGORIES).filter(
    key => STYLE_CATEGORIES[key].enabledByDefault
  ),

  showAircrafts: false,
  showExtrusion: false,
  showAirports: true,
};

export default function reduce(
  state = INITIAL_STATE,
  {
    type,
    viewport,
    center,
    visibleAirspaces,
    background,
    styleCategory,
    showExtrusion,
    showAirports,
    showAircrafts,
    selectedFeature,
    fitBounds,
  }
) {
  switch (type) {
    case MAP_SET_VIEWPORT:
      return {
        ...state,
        viewport,
      };

    case MAP_RESET_VIEWPORT:
      return {
        ...state,
        viewport: INITIAL_STATE.viewport,
      };

    case MAP_SET_BACKGROUND:
      return {
        ...state,
        background,
      };

    case MAP_TOGGLE_STYLE_CATEGORY:
      return {
        ...state,
        styleCategories: state.styleCategories.includes(styleCategory)
          ? without(state.styleCategories, styleCategory)
          : [...state.styleCategories, styleCategory],
      };

    case MAP_TOGGLE_EXTRUSION_RAW:
      return {
        ...state,
        showExtrusion,
      };

    case MAP_TOGGLE_EXTRUSION:
      return {
        ...state,
        viewport: {
          ...state.viewport,
          pitch: showExtrusion ? 60 : 0,
        },

        showExtrusion,
      };

    case MAP_TOGGLE_AIRPORTS:
      return {
        ...state,
        showAirports,
      };

    case MAP_TOGGLE_AIRCRAFTS:
      return {
        ...state,
        showAircrafts,
      };

    case MAP_SET_CENTER:
      return {
        ...state,
        viewport: {
          ...state.viewport,
          center,
        },
      };

    case MAP_SET_VISIBLE_AIRSPACES:
      return {
        ...state,
        visibleAirspaces,
      };

    case MAP_SET_SELECTED_FEATURE:
      return {
        ...state,
        selectedFeature,
      };

    case MAP_SET_FIT_BOUNDS:
      return {
        ...state,
        viewport: {
          ...state.viewport,
          fitBounds,
        },
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/map.js